import { ReactElement } from "react";
import { cancelwaitUsers } from "../../types/Reievespf001";

interface cancelwaitUsersModalProps{
    users: cancelwaitUsers[];
    onClick: () => void;
}


/**
 * キャンセル待ちの会員モーダルのコンポーネント
 * @returns 
 */
export function CancelWaitUsersList(props: cancelwaitUsersModalProps): ReactElement{

    return(
        <>
            <div className="overlay-box">
                <div className="modal-box">
                    <div className="modal-base">
                        <div className="mdl-wrap">
                            <button 
                                className="mdl-close-btn"
                                onClick={props.onClick}
                            />

                            <div className="mdl-cont">
                                <div className="mdl-ttl">
                                    キャンセル待ちの会員
                                </div>
                                {props.users.length === 0 ?
                                    <div className="mdl-scr-box">
                                        <div className="list-view">
                                            <dl>現在キャンセル待ちの会員はいません。</dl>
                                        </div>
                                    </div>
                                    :
                                    <div className="mdl-scr-box">
                                        <div className="list-view">
                                            {props.users.map((user, index) => (
                                                <dl key={index}>
                                                    <dt className="no">{index + 1}</dt>
                                                    <dd>{user.name}様</dd>
                                                </dl>
                                            ))}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="overlay-bg" />
        </>
        
    );

}